import { Button } from '@mui/material';
import React from 'react';
import { firestore } from '../../../../../contexts/FirebaseContext';

function SectionEliminarEnv({ dataEnvio }) {
  console.log(dataEnvio);
  const deleteEnvio = async () => {
    await firestore.collection('cotizaciones').doc(dataEnvio?.id).delete();
    console.log('eliminado');
  };
  return (
    <div>
      <Button onClick={deleteEnvio}>Elimnar</Button>
    </div>
  );
}

export default SectionEliminarEnv;
